/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum EncounterPatientDetailAliases {
  BUTTON_VIEW_PRESCRIPTIONS = 'button-view-prescriptions',
  CONTAINER_PANEL_BUTTON_VIEW_PRESCRIPTIONS = 'container-panel-button-view-prescriptions',
  CONTAINER_PANEL_BUTTON_VIEW_PRESCRIPTIONS_PADDING = 'container-panel-button-view-prescriptions-padding',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  FRAGMENT_SUEP = 'fragment-suep',
  GENERAL_LAYOUT = 'general-layout',
  PANEL_BUTTON_VIEW_PRESCRIPTIONS = 'panel-button-view-prescriptions',
  PANEL_CONTAINER_MAIN = 'panel-container-main',
  TEXT_AREA_PANEL = 'text-area-panel',
}
export { EncounterPatientDetailAliases };
